import React from "react";

export default function PhoneIcon(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.1503 11.9258C13.8797 11.7672 13.547 11.7705 13.2777 11.9305L11.9137 12.7432C11.6083 12.9252 11.227 12.9038 10.947 12.6852C10.463 12.3072 9.68366 11.6712 9.00566 10.9932C8.32766 10.3152 7.69166 9.53582 7.31366 9.05182C7.095 8.77182 7.07366 8.39049 7.25566 8.08516L8.06833 6.72115C8.229 6.45182 8.23033 6.11649 8.07166 5.84582L6.07033 2.42716C5.87633 2.09649 5.491 1.93382 5.11833 2.02516C4.75633 2.11316 4.28633 2.32782 3.79366 2.82116C2.251 4.36382 1.43166 6.96582 7.233 12.7672C13.0343 18.5685 15.6357 17.7498 17.179 16.2065C17.673 15.7125 17.887 15.2418 17.9757 14.8792C18.0657 14.5072 17.9057 14.1245 17.5757 13.9312C16.7517 13.4492 14.9743 12.4085 14.1503 11.9258Z"
        fill="#333333"
      />
    </svg>
  );
}
